/**
 * @enum {string}
 */
var RoleType;
(function (RoleType) {
    RoleType["DASHBOARD"] = "DASHBOARD";
    RoleType["DASHBOARD_TRIAL"] = "DASHBOARD_TRIAL";
    RoleType["SEEK"] = "SEEK";
    RoleType["SEEK_TRIAL"] = "SEEK_TRIAL";
    RoleType["SIDEKICK"] = "SIDEKICK";
    RoleType["WHEREHOUSE"] = "WHEREHOUSE";
})(RoleType || (RoleType = {}));
;
export default RoleType;
